import styled from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  padding: 16px;
  max-width: 430px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
  flex-grow: 1;

  @media only screen and (min-width: 768px) {
    min-width: 350px;
  }
`

export default Wrapper(template);